import { Box, Container,Grid } from "@mui/material";
import React from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import AboutUs from "./components/AboutUs";
import Product from "./components/Product";
import ArticlePage from "./components/article/ArticlePage";
import ArticleJsonData from "./components/article/ArticleJsonData";
import MyHome from "./components/Home";
import Article from "./components/article/Article";
import Disclaimer from "./components/footer/disclaimer";
import TermsOfUse from "./components/footer/terms-of-use"
import PrivacyPolicy from "./components/footer/privacy-policy";
import CaliforniaPolicy from "./components/footer/california-policy";
import  Security  from "./components/footer/security";
import KSLoanAppbar from "./components/navbar/app-bar";
import { useState, useEffect } from "react";
import Cal5 from "./components/calculators/Cal5";
import Topic1 from "./components/trendingtopics/Topic1";
import {
  NavAppBar,
  BannerImg,
  TrendingTopics,
  SearchBox,
  Footer,

  ArticlePage1,
  ArticlePage2,
  ArticlePage3,
  ArticlePage4,
  ArticlePage5,
  ArticlePage6,
  Cal1,
  Cal2,
  Cal3,
  Cal4
} from "./components";
import { Topic } from "@mui/icons-material";
import Topic2 from "./components/trendingtopics/Topic2";
import Topic3 from "./components/trendingtopics/Topic3";
import Topic4 from "./components/trendingtopics/Topic4";





const customStyle = makeStyles({
  bodyColor: {
    backgroundColor: "#fcfcfc",
  },
});

function CalculatorFunction() {
  const { card } = useParams();

  let renderedComponent;

  if (card === "1") {
    renderedComponent = <Cal2 />;
  } else if (card === "2") {
    renderedComponent = <Cal5 />;
  } else  if (card === "3") {
      renderedComponent = <Cal5 />;
  } else if (card === "4") {
    renderedComponent = <Cal5 />;
  }

  return (
    <>
      {renderedComponent}
    </>
  );
}

const filename = 'Article1';
const filename2 = 'Article2';

function ArticleFunction() {
  const { id } = useParams();

  let renderedComponent;


  if (id === "1") {
    renderedComponent = <Article filename={filename} />; // Assign the JSX element to the variable
  } else if (id === "2") {
    renderedComponent = <Article filename={filename2} />; // Assign the JSX element to the variable
  } else {
    // Handle the case when the id doesn't match any articles
    renderedComponent = <div>No article found for this id.</div>;

  }

  
/*
  if (id === "1") {
    //renderedComponent = <ArticlePage1  />;
    <Article filename={filename} />
  } else if (id === "2") {
    //renderedComponent = <ArticlePage2 />;
    <Article filename={filename2} />
  } else if (id === "3") {
    renderedComponent = <ArticlePage3 />;
  } else if (id === "4") {
    renderedComponent = <ArticlePage4 />;
  } else if (id === "5") {
    renderedComponent = <ArticlePage5 />;
  } else if (id === "6") {
    renderedComponent = <ArticlePage6 />;*/
 

  return (
    <div>
      {/* Other component contents */}
      {renderedComponent}
    </div>
  );
}


function ArticlePageFunction() {
  const { id } = useParams();

  let renderedComponent;

  if (id === "1") {
    renderedComponent = <ArticlePage1  />;
  } else if (id === "2") {
    renderedComponent = <ArticlePage2 />;
  } else if (id === "3") {
    renderedComponent = <ArticlePage3 />;
  } else if (id === "4") {
    renderedComponent = <ArticlePage4 />;
  } else if (id === "5") {
    renderedComponent = <ArticlePage5 />;
  } else if (id === "6") {
    renderedComponent = <ArticlePage6 />;
  } else {
   
  }

  return (
    <div>
      {/* Other component contents */}
      {renderedComponent}
    </div>
  );
}




function App() {

// Load the state from LocalStorage if it exists, or set initial state if not
const [appState, setAppState] = useState(
  JSON.parse(localStorage.getItem("appState")) || {}
);

// Save the state to LocalStorage whenever it changes
useEffect(() => {
  localStorage.setItem("appState", JSON.stringify(appState));
}, [appState]);


  

  
  const classes = customStyle();

  return (
    <Grid lg={12} margin={0} ml={0} mr={0}>
 
        <BrowserRouter>
          {/* <NavAppBar /> */}
          <KSLoanAppbar/>
          {/*<ArticleCatalogue/>*/}

          <Routes>
            <Route path="/support" element={<MyHome />} />
          {/*  <Route path="/article/:id/:title" element={<ArticleFunction />} />*/ }
           <Route path="/support/article/:id/:title" element={<ArticlePageFunction />} /> 
           {/* <Route path="/article/:id/:title" element={<ArticlePage data={ArticleJsonData} />} */}
            <Route path="/support/mortgage-cal-type/:card" element={<CalculatorFunction />} />
            <Route path="/support/disclaimer" element={<Disclaimer />} />
            <Route path="/support/terms-of-use" element={<TermsOfUse />} />
            <Route path="/support/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/support/california-policy" element={<CaliforniaPolicy />} />
            <Route path="/support/security-policy" element={<Security />} />
            <Route path="/support/loan-document" element={<Topic1 />} />
            <Route path="/support/pre-approval-process" element={<Topic2 />} />
            <Route path="/support/credit-scores" element={<Topic3 />} />
            <Route path="/support/down-payment-strategies" element={<Topic4 />} />
            
          </Routes>
        
        
          <Footer />
        </BrowserRouter>
  
        </Grid>
  );
}

export default App;
